import React from 'react';

// Guest only. Covers the room while the host has not yet let the guest in.
const MESSAGES = {
  waiting: ['Please wait', 'The host will let you in shortly. Keep this page open.'],
  denied: ['You cannot join this meeting', 'The host did not admit you.'],
  full: ['The waiting room is full', 'Please try again in a few minutes.'],
};

export default function WaitingRoomOverlay({ status }) {
  const message = MESSAGES[status];
  if (!message) return null;
  const [title, text] = message;
  return (
    <div
      role="status"
      aria-live="polite"
      style={{
        position: 'fixed', inset: 0, zIndex: 2000, background: 'rgba(0,0,0,0.88)',
        display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 24,
      }}
    >
      <div style={{ color: '#fff', textAlign: 'center', maxWidth: 420 }}>
        <h2 style={{ marginBottom: 12 }}>{title}</h2>
        <p style={{ color: '#ccc', lineHeight: 1.5 }}>{text}</p>
      </div>
    </div>
  );
}
